"use strict";

var _classCallCheck = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/konsta/Documents/GitHub/bluedex/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var bip39 = __importStar(require("ethereum-cryptography/bip39"));
var english_1 = require("ethereum-cryptography/bip39/wordlists/english");
var EthUtil = __importStar(require("ethereumjs-util"));
var ethereumjs_wallet_1 = __importDefault(require("ethereumjs-wallet"));
var ethereumjs_wallet_2 = require("ethereumjs-wallet");
var tx_1 = require("@ethereumjs/tx");
var common_1 = __importDefault(require("@ethereumjs/common"));
// @ts-ignore
var web3_provider_engine_1 = __importDefault(require("@trufflesuite/web3-provider-engine"));
var filters_1 = __importDefault(require("@trufflesuite/web3-provider-engine/subproviders/filters"));
var nonce_tracker_1 = __importDefault(require("@trufflesuite/web3-provider-engine/subproviders/nonce-tracker"));
var hooked_wallet_1 = __importDefault(require("@trufflesuite/web3-provider-engine/subproviders/hooked-wallet"));
var provider_1 = __importDefault(require("@trufflesuite/web3-provider-engine/subproviders/provider"));
// @ts-ignore
var rpc_1 = __importDefault(require("@trufflesuite/web3-provider-engine/subproviders/rpc"));
// @ts-ignore
var websocket_1 = __importDefault(require("@trufflesuite/web3-provider-engine/subproviders/websocket"));
var url_1 = __importDefault(require("url"));
var getOptions_1 = require("./constructor/getOptions");
var getPrivateKeys_1 = require("./constructor/getPrivateKeys");
var getMnemonic_1 = require("./constructor/getMnemonic");
var eth_sig_util_1 = require("eth-sig-util");
// Important: do not use debug module. Reason: https://github.com/trufflesuite/truffle/issues/2374#issuecomment-536109086
// This line shares nonce state across multiple provider instances. Necessary
// because within truffle the wallet is repeatedly newed if it's declared in the config within a
// function, resetting nonce from tx to tx. An instance can opt out
// of this behavior by passing `shareNonce=false` to the constructor.
// See issue #65 for more
var singletonNonceSubProvider = new nonce_tracker_1.default();
var HDWalletProvider = /*#__PURE__*/function () {
  function HDWalletProvider() {
    _classCallCheck(this, HDWalletProvider);
    var _a = getOptions_1.getOptions.apply(getOptions_1, arguments),
      provider = _a.provider,
      url = _a.url,
      providerOrUrl = _a.providerOrUrl,
      _a$addressIndex = _a.addressIndex,
      addressIndex = _a$addressIndex === void 0 ? 0 : _a$addressIndex,
      _a$numberOfAddresses = _a.numberOfAddresses,
      numberOfAddresses = _a$numberOfAddresses === void 0 ? 10 : _a$numberOfAddresses,
      _a$shareNonce = _a.shareNonce,
      shareNonce = _a$shareNonce === void 0 ? true : _a$shareNonce,
      _a$derivationPath = _a.derivationPath,
      derivationPath = _a$derivationPath === void 0 ? "m/44'/60'/0'/0/" : _a$derivationPath,
      _a$pollingInterval = _a.pollingInterval,
      pollingInterval = _a$pollingInterval === void 0 ? 4000 : _a$pollingInterval,
      chainId = _a.chainId,
      _a$chainSettings = _a.chainSettings,
      chainSettings = _a$chainSettings === void 0 ? {} : _a$chainSettings,
      signingAuthority = __rest(_a, ["provider", "url", "providerOrUrl", "addressIndex", "numberOfAddresses", "shareNonce", "derivationPath", "pollingInterval", "chainId", "chainSettings"]);
    var mnemonic = getMnemonic_1.getMnemonic(signingAuthority);
    var privateKeys = getPrivateKeys_1.getPrivateKeys(signingAuthority);
    this.walletHdpath = derivationPath;
    this.wallets = {};
    this.addresses = [];
    this.chainSettings = chainSettings;
    this.engine = new web3_provider_engine_1.default({
      pollingInterval: pollingInterval
    });
    var providerToUse;
    if (HDWalletProvider.isValidProvider(provider)) {
      providerToUse = provider;
    } else if (HDWalletProvider.isValidProvider(url)) {
      providerToUse = url;
    } else {
      providerToUse = providerOrUrl;
    }
    if (!HDWalletProvider.isValidProvider(providerToUse)) {
      throw new Error(["No provider or an invalid provider was specified: '".concat(providerToUse, "'"), "Please specify a valid provider or URL, using the http, https, " + "ws, or wss protocol.", ""].join("\n"));
    }
    if (mnemonic && mnemonic.phrase) {
      this.checkBIP39Mnemonic(Object.assign(Object.assign({}, mnemonic), {
        addressIndex: addressIndex,
        numberOfAddresses: numberOfAddresses
      }));
    } else if (privateKeys) {
      var options = Object.assign({}, {
        privateKeys: privateKeys
      }, {
        addressIndex: addressIndex
      });
      this.ethUtilValidation(options);
    } // no need to handle else case here, since matchesNewOptions() covers it
    if (this.addresses.length === 0) {
      throw new Error("Could not create addresses from your mnemonic or private key(s). " + "Please check that your inputs are correct.");
    }
    var tmpAccounts = this.addresses;
    var tmpWallets = this.wallets;
    // if user supplied the chain id, use that - otherwise fetch it
    if (typeof chainId !== "undefined" || chainSettings && typeof chainSettings.chainId !== "undefined") {
      this.chainId = chainId || chainSettings.chainId;
      this.initialized = Promise.resolve();
    } else {
      this.initialized = this.initialize();
    }
    // EIP155 compliant transactions are enabled for hardforks later
    // than or equal to "spurious dragon"
    this.hardfork = chainSettings && chainSettings.hardfork ? chainSettings.hardfork : "london";
    var self = this;
    this.engine.addProvider(new hooked_wallet_1.default({
      getAccounts: function getAccounts(cb) {
        cb(null, tmpAccounts);
      },
      getPrivateKey: function getPrivateKey(address, cb) {
        if (!tmpWallets[address]) {
          return cb("Account not found");
        } else {
          cb(null, tmpWallets[address].getPrivateKey().toString("hex"));
        }
      },
      signTransaction: function signTransaction(txParams, cb) {
        return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var pkey, from, chain, KNOWN_CHAIN_IDS, txOptions, hasEip1559, tx, signedTx, rawTx;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return self.initialized;
                case 2:
                  // we need to rename the 'gas' field
                  txParams.gasLimit = txParams.gas;
                  delete txParams.gas;
                  from = txParams.from.toLowerCase();
                  if (tmpWallets[from]) {
                    pkey = tmpWallets[from].getPrivateKey();
                  } else {
                    cb("Account not found");
                  }
                  chain = self.chainId;
                  KNOWN_CHAIN_IDS = new Set([1, 3, 4, 5, 42]);
                  if (typeof chain !== "undefined" && KNOWN_CHAIN_IDS.has(chain)) {
                    txOptions = {
                      common: new common_1.default({
                        chain: chain,
                        hardfork: self.hardfork
                      })
                    };
                  } else if (typeof chain !== "undefined") {
                    txOptions = {
                      common: common_1.default.forCustomChain(1, {
                        name: "custom chain",
                        chainId: chain
                      }, self.hardfork)
                    };
                  }
                  // Taken from https://github.com/ethers-io/ethers.js/blob/2a7ce0e72a1e0c9469e10392b0329e75e341cf18/packages/abstract-signer/src.ts/index.ts#L215
                  hasEip1559 = txParams.maxFeePerGas !== undefined || txParams.maxPriorityFeePerGas !== undefined;
                  tx = hasEip1559 ? tx_1.FeeMarketEIP1559Transaction.fromTxData(txParams, txOptions) : tx_1.Transaction.fromTxData(txParams, txOptions);
                  signedTx = tx.sign(pkey);
                  rawTx = "0x".concat(signedTx.serialize().toString("hex"));
                  cb(null, rawTx);
                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      },
      signMessage: function signMessage(_ref, cb) {
        var data = _ref.data,
          from = _ref.from;
        var dataIfExists = data;
        if (!dataIfExists) {
          cb("No data to sign");
        }
        if (!tmpWallets[from]) {
          cb("Account not found");
        }
        var pkey = tmpWallets[from].getPrivateKey();
        var dataBuff = EthUtil.toBuffer(dataIfExists);
        var msgHashBuff = EthUtil.hashPersonalMessage(dataBuff);
        var sig = EthUtil.ecsign(msgHashBuff, pkey);
        var rpcSig = EthUtil.toRpcSig(sig.v, sig.r, sig.s);
        cb(null, rpcSig);
      },
      signPersonalMessage: function signPersonalMessage() {
        this.signMessage.apply(this, arguments);
      },
      signTypedMessage: function signTypedMessage(_ref2, cb) {
        var data = _ref2.data,
          from = _ref2.from;
        var dataIfExists = data;
        if (!dataIfExists) {
          cb("No data to sign");
        }
        if (!tmpWallets[from]) {
          cb("Account not found");
        }
        var pkey = tmpWallets[from].getPrivateKey();
        var sig = eth_sig_util_1.signTypedData(pkey, {
          data: data
        });
        cb(null, sig);
      }
    }));
    !shareNonce ? this.engine.addProvider(new nonce_tracker_1.default()) : this.engine.addProvider(singletonNonceSubProvider);
    this.engine.addProvider(new filters_1.default());
    if (typeof providerToUse === "string") {
      var _url = providerToUse;
      var providerProtocol = (url_1.default.parse(_url).protocol || "http:").toLowerCase();
      switch (providerProtocol) {
        case "ws:":
        case "wss:":
          this.engine.addProvider(new websocket_1.default({
            rpcUrl: _url
          }));
          break;
        default:
          this.engine.addProvider(new rpc_1.default({
            rpcUrl: _url
          }));
      }
    } else {
      this.engine.addProvider(new provider_1.default(providerToUse));
    }
    // Required by the provider engine.
    this.engine.start(function (err) {
      if (err) throw err;
    });
  }
  _createClass(HDWalletProvider, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        _this.engine.sendAsync({
          jsonrpc: "2.0",
          id: Date.now(),
          method: "eth_chainId",
          params: []
        }, function (error, response) {
          if (error) {
            reject(error);
            return;
          } else if (response.error) {
            reject(response.error);
            return;
          }
          if (isNaN(parseInt(response.result, 16))) {
            var message = "When requesting the chain id from the node, it" + "returned the malformed result ".concat(response.result, ".");
            throw new Error(message);
          }
          _this.chainId = parseInt(response.result, 16);
          resolve();
        });
      });
    } // private helper to check if given mnemonic uses BIP39 passphrase protection
  }, {
    key: "checkBIP39Mnemonic",
    value: function checkBIP39Mnemonic(_ref3) {
      var addressIndex = _ref3.addressIndex,
        numberOfAddresses = _ref3.numberOfAddresses,
        phrase = _ref3.phrase,
        password = _ref3.password;
      this.hdwallet = ethereumjs_wallet_2.hdkey.fromMasterSeed(bip39.mnemonicToSeedSync(phrase, password));
      if (!bip39.validateMnemonic(phrase, english_1.wordlist)) {
        throw new Error("Mnemonic invalid or undefined");
      }
      // crank the addresses out
      for (var i = addressIndex; i < addressIndex + numberOfAddresses; i++) {
        var wallet = this.hdwallet.derivePath(this.walletHdpath + i).getWallet();
        var addr = "0x".concat(wallet.getAddress().toString("hex"));
        this.addresses.push(addr);
        this.wallets[addr] = wallet;
      }
    } // private helper leveraging ethUtils to populate wallets/addresses
  }, {
    key: "ethUtilValidation",
    value: function ethUtilValidation(_ref4) {
      var addressIndex = _ref4.addressIndex,
        privateKeys = _ref4.privateKeys;
      // crank the addresses out
      for (var i = addressIndex; i < privateKeys.length; i++) {
        var privateKey = Buffer.from(privateKeys[i].replace("0x", ""), "hex");
        if (EthUtil.isValidPrivate(privateKey)) {
          var wallet = ethereumjs_wallet_1.default.fromPrivateKey(privateKey);
          var address = wallet.getAddressString();
          this.addresses.push(address);
          this.wallets[address] = wallet;
        }
      }
    }
  }, {
    key: "send",
    value: function send(payload, callback) {
      var _this2 = this;
      this.initialized.then(function () {
        _this2.engine.send(payload, callback);
      });
    }
  }, {
    key: "sendAsync",
    value: function sendAsync(payload, callback) {
      var _this3 = this;
      this.initialized.then(function () {
        _this3.engine.sendAsync(payload, callback);
      });
    }
  }, {
    key: "getAddress",
    value: function getAddress(idx) {
      if (!idx) {
        return this.addresses[0];
      } else {
        return this.addresses[idx];
      }
    }
  }, {
    key: "getAddresses",
    value: function getAddresses() {
      return this.addresses;
    }
  }], [{
    key: "isValidProvider",
    value: function isValidProvider(provider) {
      if (!provider) return false;
      if (typeof provider === "string") {
        var validProtocols = ["http:", "https:", "ws:", "wss:"];
        var url = url_1.default.parse(provider.toLowerCase());
        return !!(validProtocols.includes(url.protocol || "") && url.slashes);
      } else if ("request" in provider) {
        // provider is an 1193 provider
        return true;
      } else if ("send" in provider) {
        // provider is a "legacy" provider
        return true;
      }
      return false;
    }
  }]);
  return HDWalletProvider;
}();
module.exports = HDWalletProvider;